import type { Task, TreeNode } from 'types/interfaces';

import {
  attainmentsFromTask,
  type RequiredAttainment
} from './attainmentAvailability';

export type { RequiredAttainment };
export { mapEmployeeAttainments } from './attainmentAvailability';

export function extractRequiredAttainments(task: Task): RequiredAttainment[] {
  return attainmentsFromTask(task);
}

export function getTaskStatusLabel(taskStatus: Task['taskStatus']): string {
  if (!taskStatus) return '';
  if (typeof taskStatus === 'string') return taskStatus;
  return (taskStatus as TreeNode).label ?? '';
}
